import React, { useContext } from 'react';
import { required } from '@ubeya/shared/utils/form';
import InputField from '../../FormFields/InputField';
import NumberField from '../../FormFields/NumberField';
import ConfigContext from '../../../contexts/ConfigContext';
import { EditableByAdmins } from './EditableByAdmins';

const RatingFieldForm = ({ showLimitEditAdminsToggle = false }) => {
  const { t } = useContext(ConfigContext);

  return (
    <>
      <InputField
        name="name"
        title={t('name')}
        placeholder={t('selectNameToField')}
        className="full"
        validate={required}
        required
        autoFocus
      />
      <NumberField name="stars" title={t('stars')} />
      {showLimitEditAdminsToggle && <EditableByAdmins />}
    </>
  );
};

export default RatingFieldForm;
